<template>
	<div>
		<Popup
			v-model:show="transferPop"
			round
			position="bottom"
			closeable
			:close-on-click-overlay="false"
			:style="{ height: '490px' }">
			<!--      上一步-->
			<div style="position: relative;height: 100%;" v-show="stepShow==1">
				<div style="font-size: var(--base-px-14);text-align: center;padding-top: var(--base-px-15);">
					<div>转接客户</div>
					<div style="font-size: var(--base-px-13);color: #ACACAC;">可选中的客户转接给其他员工，进行后续服务</div>
				</div>
				<Divider/>
				<div class="transfer_page show_staff">
					<NoticeBar color="#BD7943" background="#FFF7F0" left-icon="info-o">
						90天内客户只能被转接两次
					</NoticeBar>
					<div style="display: flex;margin-top: var(--base-px-15);">
						<div class="row_name">选择员工</div>
					</div>
					<van-search
						placeholder="搜索"
						@search="searchEmployee"
						v-model="employeeName"
						@input="clearInput"
						:clearable="false"
					/>
					<van-list
						v-model:loading="loading"
						:finished="finished"
						finished-text="没有更多了"
					>
						<van-radio-group v-model="checkedStaff">
							<van-cell v-for="(item,index) in staffArray" :key="index">
								<div class="transfer_flex" style="cursor: pointer;" @click="selectEmployee(index)">
									<div style="display: flex;">
										<img :src="item.avatar" alt="" style="width: var(--base-px-40);height: var(--base-px-40);">
										<span style="margin-left: var(--base-px-10);line-height: var(--base-px-50);">{{ item.name }}</span>
									</div>
									<van-radio :name="index"></van-radio>
								</div>
							</van-cell>
						</van-radio-group>
					</van-list>
				</div>
				<div class="foot_btn_row">
					<van-button type="primary" block @click="determineBtn">确定</van-button>
				</div>
			</div>
			<!--      下一步-->
			<div v-show="stepShow==2">
				<div style="font-size: var(--base-px-15);text-align: center;padding-top: var(--base-px-15);">
					转接客户给{{ replaceName }}
				</div>
				<Divider/>
				<div class="transfer_page">
					<NoticeBar color="#BD7943" background="#FFF7F0" wrapable left-icon="info-o"
					           style="font-size: var(--base-px-13);">
						转接后客户将在24小时后成功转接，若客户拒绝，本次转接将不会生效
					</NoticeBar>
					<div class="transfer_flex" style="margin-top: var(--base-px-15);">
						<div style="font-size: var(--base-px-14);color: #ACACAC;">客户将收到以下消息</div>
						<div style="color: #329CFF;cursor: pointer;" @click="modifyBtn" v-if="!showModify">修改</div>
					</div>
					<div class="show-tips-info">
						<div class="show_tip_news" v-if="!showModify">
							<div class="transfer_flex">
								<img src="../../../assets/contactImg.svg" alt=""
								     style="width: var(--base-px-40);height: var(--base-px-40);">
								<div class="tip_content">{{ tipWord }}</div>
							</div>
							<div
								style="text-align: center;margin-top: var(--base-px-15);font-size: var(--base-px-15);color: #A6A8A9;">
								由于工作变更，<span style="color: #7D8DAC">{{ replaceName }}</span>将在24小时后添加为你的企业微信联系人，继续为你提供服务。
							</div>
							<div
								style="text-align: center;margin-top: var(--base-px-10);font-size: var(--base-px-15);color:  #7D8DAC;">
								暂不添加
							</div>
						</div>
						<div style="position: relative;" v-if="showModify">
							<textarea class="textarea" v-model="modifyTips"></textarea>
							<div class="textarea_btn">
								<span style="color: #545454;cursor: pointer;" @click="removeBtn">取消</span>
								<span style="color: #319BFE;cursor: pointer;" @click="saveTipSentence">保存</span>
							</div>
						</div>
						<div style="margin-top: var(--base-px-10);font-size: var(--base-px-13);color: #878787;">
							提示：客户的客户画像相关信息将会同步继承至接替员工
						</div>
					</div>
					<div class="transfer_flex transfer_foot_btn">
						<van-button plain type="primary" @click="returnBtn">返回</van-button>
						<van-button type="primary" @click="confirmTransfer">确认转接</van-button>
					</div>
				</div>
			</div>
		</Popup>
	</div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import {EmployeeApi} from '@/api/employee'
// eslint-disable-next-line no-unused-vars
import {ContactTransferApi} from '@/api/contactTransfer'
import {Divider, Popup, NoticeBar, Toast} from 'vant'

export default {
	components: {
		Divider, Popup, NoticeBar, Toast
	},
	data() {
		return {
			transferPop: false,
			finished: true,
			loading: false,
			checkedStaff: -1,
			staffArray: [],
			stepShow: 1,
			tipWord: '',
			modifyTips: '',
			showModify: false,
			replaceName: '',
			employeeName: ''
		}
	},
	methods: {
		selectEmployee(index) {
			this.checkedStaff = index
		},
		// 清空搜索框
		clearInput() {
			if (this.employeeName == '') {
				this.getEmployeeList()
			}
		},
		// 搜索员工
		searchEmployee() {
			this.getEmployeeList()
		},
		show(contactId) {
			this.contactId = contactId
			this.transferPop = true
			this.getEmployeeList()
		},
		getEmployeeList() {
			EmployeeApi.index({
				name: this.employeeName
			}).then((res) => {
				this.staffArray = res.data
			})
		},
		// 确认转接
		confirmTransfer() {
			if (this.tipWord == '') {
				Toast('客户收到的提示不能为空')
				return false
			}
			ContactTransferApi.transfer({
				contactId: this.contactId,
				employeeId: this.staffArray[this.checkedStaff].id,
				content: this.tipWord
			}).then((res) => {
				Toast('转接成功')
				this.transferPop = false
				this.checkedStaff = -1
				this.stepShow = 1
			})
		},
		// 保存
		saveTipSentence() {
			this.tipWord = JSON.parse(JSON.stringify(this.modifyTips))
			this.showModify = false
		},
		// 取消按钮
		removeBtn() {
			this.showModify = false
		},
		// 修改按钮
		modifyBtn() {
			this.showModify = true
			this.modifyTips = JSON.parse(JSON.stringify(this.tipWord))
		},
		// 返回按钮
		returnBtn() {
			this.stepShow--
		},
		// 确定按钮
		determineBtn() {
			if (this.checkedStaff == -1) {
				Toast('请选择要转接的员工')
				return false
			}
			this.replaceName = this.staffArray[this.checkedStaff].name
			this.tipWord = '您好，您的服务已升级，后续将由我的同事@' + this.replaceName + '接替我的工作，继续为您服务。'
			this.stepShow++
		}
	}
}
</script>
<style scoped lang="less">
.transfer_flex {
	display: flex;
	justify-content: space-between;
}

.transfer_page {
	padding: 0 var(--base-px-35);
	font-size: var(--base-px-28);
	color: #333;
}

.show_staff {
	height:  var(--base-px-720);
	overflow-y: scroll;
}

.row_name {
	font-size: var(--base-px-29);
	border-left: var(--base-px-7) solid #1890FF;
	height: var(--base-px-35);
	line-height: var(--base-px-40);
	padding-left: var(--base-px-10);
}

.foot_btn_row {
	position: absolute;
	bottom: var(--base-px-10);
	left: var(--base-px-35);
	width: calc(100% - var(--base-px-70));
}

.show_tip_news {
	padding: var(--base-px-50) var(--base-px-30) var(--base-px-30);
	background: #F0F0F0;
	margin-top: var(--base-px-15);
	border-radius: var(--base-px-5);
}

.tip_content {
	width: 100%;
	background: #fff;
	padding: var(--base-px-20) var(--base-px-40);
	margin-left: var(--base-px-20);
}

.transfer_foot_btn {
	margin-top: var(--base-px-10);
	margin-bottom: var(--base-px-20);

	button {
		width: calc(50% - var(--base-px-10));
		height: var(--base-px-75);
	}
}

.textarea {
	margin-top: var(--base-px-15);
	width: calc(100% - var(--base-px-60));
	height:  var(--base-px-400);
	padding: var(--base-px-50) var(--base-px-30) var(--base-px-50) var(--base-px-30);
	resize: none;
	border: 0;
	background: #F0F0F0;
}

.textarea_btn {
	position: absolute;
	bottom: var(--base-px-30);
	right: 0;

	span {
		margin-right: var(--base-px-30);
	}
}

.show-tips-info {
	min-height:  var(--base-px-530);
}
</style>
